import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Slider } from 'Components/frameworks/slider/Slider';
import type { AnimationEvent } from './EventAnimationSlide';
import './EventAnimationSlide';
type Props = {
  events: Array<AnimationEvent>;
  index: number;
  onIndex: (event: React.SyntheticEvent | KeyboardEvent | undefined, index: number) => void;
};
export const EventAnimationTitles = ({ events, index, onIndex }: Props) => {
  const { isTablet } = useResponsive();
  const buttons = events.map(({ content }, offerIndex) => {
    const isActive = offerIndex === index;
    const color = content.theming.backgroundColor;
    return (
      <button
        className={classnames(
          [
            `relative isolate mb-20 whitespace-nowrap pb-5 text-14 sm:mx-20 sm:whitespace-normal text-${color} hocus:text-${color}-active`,
          ],

          {
            'font-bold': isActive,
            'ms-20': offerIndex !== 0,
          },
        )}
        key={content.title}
        onClick={(e) => {
          onIndex(e, offerIndex);
        }}
        type="button"
      >
        {content.title}
        <div
          className={classnames(
            'h-2',
            [`bg-${color} transition-transform absolute top-full w-full scale-x-0`],
            {
              'scale-x-1 transform': isActive,
            },
          )}
        />
      </button>
    );
  });
  return !isTablet ? (
    <Slider
      {...asWidgetProps<ComponentProps<typeof Slider>>({
        cols: 0,
        hasControls: false,
        navPosition: 'center',
        nbItemsToScroll: 1,
        initialIndex: index,
        nextLabel: t('common.next'),
        previousLabel: t('common.previous'),
        scrollAreaClassName: 'overflow-hidden',
        scrollAreaContainerClassName:
          'overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory',
        scrollItemClassName: 'overflow-hidden flex-none max-w-full',
      })}
    >
      {buttons}
    </Slider>
  ) : (
    <div className="flex items-center justify-center">{buttons}</div>
  );
};
